import type { LayeredConstructionCatalogItem, LayerFormValue } from "../model/types";

import { buildLayerFormValues, parseMaterialNames } from "./layers";

export const getCatalogMaterialNames = (catalog: Pick<LayeredConstructionCatalogItem, "materialNames">[]): string[] => {
  const names = new Set<string>();
  catalog.forEach((item) => {
    parseMaterialNames(item.materialNames).forEach((name) => {
      if (name.trim()) names.add(name);
    });
  });
  return [...names].sort();
};

export const findCatalogLayerByMaterial = (
  catalog: LayeredConstructionCatalogItem[],
  materialName: string,
  preferredTypeName?: string
): LayerFormValue | undefined => {
  const normalizedMaterial = materialName.trim();
  if (!normalizedMaterial) return undefined;

  const preferredItem = preferredTypeName ? catalog.find((item) => item.typeName === preferredTypeName) : undefined;
  const catalogItems = preferredItem ? [preferredItem, ...catalog.filter((item) => item !== preferredItem)] : catalog;

  for (const item of catalogItems) {
    const match = buildLayerFormValues(item).find((layer) => String(layer.material).trim() === normalizedMaterial);
    if (match) return match;
  }

  return undefined;
};

export const findCatalogItem = (
  catalog: LayeredConstructionCatalogItem[],
  typeName: string
): LayeredConstructionCatalogItem | undefined => {
  if (!typeName) return undefined;
  return catalog.find((item) => item.typeName === typeName);
};

export const findCatalogItemById = (
  catalog: LayeredConstructionCatalogItem[],
  typeDbId?: number
): LayeredConstructionCatalogItem | undefined =>
  typeDbId == null ? undefined : catalog.find((item) => item.id === typeDbId);
